import React from "react";
import ReactDOM from "react-dom/client";
import { UnoStoreHooks, unoStore } from "@simulanisindia/ui";
import App from "./App";
import "./Assest/css/main.scss";
import "./Assest/css/responsive.scss";

import { BrowserRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));

const { UnoProvider } = UnoStoreHooks;

root.render(
  <UnoProvider store={unoStore}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </UnoProvider>
);
